<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">
        <ion-icon size="large" name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    @if (!isEdit) {
    <ion-title>{{ "user.new" | translate }}</ion-title>
    } @if (isEdit) {
    <ion-title>{{ "user.edit" | translate }}</ion-title>
    }
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true">
  <div class="container">
    <div>
      <ion-input
        labelPlacement="floating"
        fill="outline"
        type="text"
        mode="md"
        [(ngModel)]="this.user.firstName"
        ><div slot="label">{{ "user.firstName" | translate }}</div></ion-input
      >
      <ion-input
        labelPlacement="floating"
        fill="outline"
        type="text"
        mode="md"
        [(ngModel)]="this.user.lastName"
        ><div slot="label">{{ "user.lastName" | translate }}</div></ion-input
      >
      @if (!this.isEdit && userExists()) {
      <div style="padding: 10px">
        {{ "user.alreadyExists" | translate }}
      </div>
      }
      <ion-input
        labelPlacement="floating"
        fill="outline"
        type="number"
        mode="md"
        [(ngModel)]="this.user.workingHoursPerDay"
        ><div slot="label">{{ "user.hoursPerDay" | translate }}</div></ion-input
      >
      <ion-input
        labelPlacement="floating"
        fill="outline"
        type="text"
        mode="md"
        [(ngModel)]="this.user.personalNumber"
        ><div slot="label">
          {{ "user.personalNumber" | translate }}
        </div></ion-input
      >
      <ion-select
        [label]="'common.type' | translate"
        label-placement="floating"
        fill="outline"
        [(ngModel)]="this.user.type"
        mode="md"
      >
        @for (tp of userTypes; track tp) {
        <ion-select-option [value]="tp">
          {{ getUserTypeLabel(tp) }}
        </ion-select-option>
        }
      </ion-select>
      <div style="padding: 0 6px; margin-bottom: 10px">
        <ion-toggle
          helperText="Wirkt sich auf verschiedenen Funktionen aus. Siehe Hilfe im Bereich Mitarbeiter"
          justify="space-between"
          [(ngModel)]="this.user.recievesFixedSalary"
        >
          {{ "user.fixedSalary" | translate }}
        </ion-toggle>
      </div>

      @if (this.showPassword) {
      <ion-input
        labelPlacement="floating"
        [label]="'common.password' | translate"
        fill="outline"
        type="text"
        mode="md"
        [(ngModel)]="this.user.password"
      >
        <ion-icon
          name="refresh-outline"
          slot="end"
          (click)="generatePassword()"
          style="cursor: pointer; font-size: 1.5em"
        ></ion-icon>
      </ion-input>
      }
      <!--div class="select-form">
              <ion-checkbox
                stlye="margin-bottom:10px"
                [(ngModel)]="this.report.securityCheck"
                >Sicherheitscheck</ion-checkbox
                >
              </div-->

      @if (showPassword) {
      <div style="padding: 0 5px 5px 5px">
        {{ "user.passwordHint" | translate }}
      </div>
      } @if (isEdit) {
      <div class="wide top-item">
        <div>{{ "common.username" | translate }}:</div>
        <div>
          {{ this.userToEdit.userName }}
        </div>
      </div>
      } @if (isEdit) {
      <div class="wide normal-item">
        <div>{{ "common.created" | translate }}:</div>
        <div>
          {{ tools.formatDt(this.userToEdit.createdUtc) }}
          {{ tools.formatTime(this.userToEdit.createdUtc) }}
        </div>
      </div>
      } @if (isEdit) {
      <div class="wide normal-item">
        <div>{{ "user.lastOnline" | translate }}:</div>
        <div>
          {{ tools.formatDt(this.userToEdit.lastLogin) }}
          {{ tools.formatTime(this.userToEdit.lastLogin, true) }}
        </div>
      </div>
      } @if (isEdit && this.user.isDeactivated) {
      <div class="wide normal-item">
        <div>{{ "user.deactivated" | translate }}:</div>
        <div>
          {{ tools.formatDt(this.userToEdit.deactivatedUtc) }}
          {{ tools.formatTime(this.userToEdit.deactivatedUtc) }}
        </div>
      </div>
      }
    </div>
    <div [ngClass]="{ ios: this.platform.is('ios') }">
      @if (isEdit && !showPassword && !this.user.isDeactivated) {
      <ion-button (click)="this.generatePassword()">{{
        "user.generatePassword" | translate
      }}</ion-button>
      } @if (!isEdit) {
      <ion-button [disabled]="hasInvalidFields()" (click)="registerUser()">{{
        "user.register" | translate
      }}</ion-button>
      } @if (isEdit && !this.user.isDeactivated) {
      <ion-button [disabled]="hasInvalidFields()" (click)="updateUser()">{{
        "user.update" | translate
      }}</ion-button>
      } @if (isEdit && !this.user.isDeactivated) {
      <ion-button color="warning" (click)="deactivateUser()">{{
        "user.deactivate" | translate
      }}</ion-button>
      } @if (this.user.isDeactivated) {
      <ion-button color="success" (click)="activateUser()">{{
        "user.activate" | translate
      }}</ion-button>
      } @if (isEdit) {
      <ion-button color="danger" (click)="deleteUser()">{{
        "common.delete" | translate
      }}</ion-button>
      }
    </div>
  </div>
</ion-content>
